"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyPagesLayoutPage = void 0;
var _components = require("../../components");
var _internal = require("./internal");
var _MyPagesLayout = require("./internal/MyPagesLayout");
var _jsxRuntime = require("react/jsx-runtime");
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- used in tsdoc ref

/**
 * This component represents a layout specifically designed for "My Pages".
 * It wraps the provided content within a Root component and applies a DefaultLayout.
 *
 * @param children - The content to be rendered within the layout.
 * @param defaultLayoutProps - Props for the MyPagesLayout (DefaultLayout) component, use {@link prepareMyPagesLayoutProps} to fill up these props.
 * @returns A JSX element representing the MyPagesLayout.
 *
 * @remarks
 * This component is composed of a Root component, a `DefaultLayout`, and `MyPagesLayoutContent`.
 * It also includes a `personal menu` root element.
 *
 * @example
 * ```tsx
 * <MyPagesLayout>
 *   <ExampleContent />
 * </MyPagesLayout>
 * ```
 */
const MyPagesLayoutPage = ({
  children,
  layout,
  page
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_internal.Root, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Page, {
    ...page,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyPagesLayout.MyPagesLayout, {
      ...layout,
      children: children
    })
  })
});
exports.MyPagesLayoutPage = MyPagesLayoutPage;
